import Vue from 'vue'

export default {
  setLocale: (state, { locale }) => {
    state.locale = locale
  },
  setLanguage: (state, { lang }) => {
    state.currentLanguage = lang
  },
  setCurrency: (state,  cur ) => {
    state.selectedCurrency = cur
  },
  setCurrencyName: (state,  curName ) => {
    state.selectedCurrencyName = curName
  },
  setDomain: (state, { domain }) => {
    state.domain = domain
  },
  setContainerClass: (state, className ) => {
    state.containerClass = className
  },
  setLayout: (state, payload ) => {
    state.layout = payload
  },
  setPredectiveData (state, payload) {
    state.predectiveData = payload
  },
  setSearchRQ: (state, searchRQ) => {
    state.air.searchRQ = searchRQ;
  },
  setSearchRS: (state, searchRS) => {
    state.air.searchRS = searchRS;
  },
  setReviewRS: (state, reviewRS) => {
    state.air.reviewRS = reviewRS;
  },
  setPriceRS:  (state, priceRS) => {
    state.air.priceRS = priceRS;
  },
  setPNRRS: (state, pnrRS) => {
    state.air.pnrRS = pnrRS;
  },
  setTicketRS: (state, ticketRS) => {
    state.air.ticketRS = ticketRS;
  },
  setTravellers: (state, travellers) => {
    state.travellers = travellers;
  },
  setModify: (state, modify) => {
    state.modify = modify;
  },
  setCustomerInfo: (state, customerData) => {
    state.customerData = customerData.user
    state.access_token = customerData.token
    if(customerData.token){
      state.loggedin = true
    }else{
      state.loggedin = false
    }
  },
  
}



// WEBPACK FOOTER //
// src/store/mutations.js